export default {"src":"/_next/static/media/badge_google_play.1522dfd7.svg","height":1604,"width":5436};